export default "__VITE_ASSET__DDoUiU0P__"